import { render, staticRenderFns } from "./CheckFlows2.vue?vue&type=template&id=050096ce&scoped=true"
import script from "./CheckFlows2.vue?vue&type=script&lang=js"
export * from "./CheckFlows2.vue?vue&type=script&lang=js"
import style0 from "./CheckFlows2.vue?vue&type=style&index=0&id=050096ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050096ce",
  null
  
)

export default component.exports